import { render } from "./demande.vue?vue&type=template&id=12add9cc&scoped=true"
import script from "./demande.vue?vue&type=script&lang=js"
export * from "./demande.vue?vue&type=script&lang=js"

import "./demande.vue?vue&type=style&index=0&id=12add9cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12add9cc"]])

export default __exports__